import React from "react"
import Helmet from "react-helmet"
import SEO from "../../components/seo"

function FormPage () {

return (
<>
<SEO title="Total Station Domination Station Score"/> 
<div className="pt-6">
    <img className="mx-auto" width="220px" alt="" src="https://res.cloudinary.com/mysnapshot/image/upload/v1701081383/Course%20Logos/TSD_logo_horizontal_s6wa3i.png"/>
</div>
<div className="-mt-8" id="ff-compose"></div>
<Helmet>
    <style>{`
        #Publish1FAIpQLSfZw-9eNpZYw4lf2n93w2-4EhQ34uUJeWSQU-oNkY4abJCo6A {
            padding: 30px 30px; 
            
        }

        .ff-compose {
            min-height: calc(100vh - 30px);
        }

        #___gatsby {
            background-color: #FFFFFF !important;
        }

        .ff-partial {
            margin-top: 2.2em; 
        }
        
        #ff-sec-root {
            padding-top: 2em !important;
            min-height: 100%;
            
        }

        @media only screen and (min-width: 600px) {
            #ff-sec-root {
                padding-left: 10px !important; 
                padding-right: 10px !important; 
            }
          }

        .ff-section {
            padding-top: 1em;
            min-height: 100%;
        }

        .ff-section-header {
            font-size: 20px !important;
            margin-top: 0.1em !important; 
            color: #141313 !important;
            font-weight: bold !important; 
        }

        @media only screen and (max-width: 768px) {
            .ff-section {
            min-height: 100%; 
            }
        }

        .ff-form table { 
            line-height: 1.15rem; 
            margin-top: 1em;
        }

        .ff-form .ff-item label {
            font-size: 16px !important;
            font-weight: bold !important;
            padding-bottom: 0px !important; 
            margin-bottom: 8px !important; 
        }

        .ff-form .ff-item {
            padding-top: 25px !important;
        }

        .ff-success {
            padding: 80px 30px !important; 
            font-size: 18px !important; 
            height: 100vh; 
            min-height: 100% !important;
            color: #141313;
        }

        #Help1421743561 {
            color: red !important; 
            font-size: 14px; 
            line-height: 1.4em; 
            margin-top: 0.5em; 
            margin-bottom: 0.5em; 
        }

        img {
            margin-bottom: 0em !important;
        }

        .ff-next, .ff-submit, .btn-primary {
            background-color: #F4D600 !important;
            color: white !important;
            vertical-align: middle;
            align-items: center;
        } 

				.ff-next:hover, .ff-submit:hover {
        }

        .ff-back {
        }

        .ff-form table tr td { 
            border: none !important; 
        }

        .ff-button-bar {
            padding-bottom: 4em !important; 
        }

        textarea {
            margin-bottom: 0em; 
        }

        .form-control {
            outline-color: #d1d2d9 !important; 
            outline-style: solid !important; 
            outline-width: 0.05em !important;
        }

        .ff-description {
            font-size: 16px;
        }

        #ff-desc-2016523132 {
            margin-top: 2em !important; 
        }

        .ff-scale input {
            width: 18px;
            height: 18px;
        }

        @media only screen and (max-width: 600px) {
            .ff-scale input {
              width: 12px;
              height: 12px;
            }
          }

        table {
            margin-bottom: 0em !important;
        }

        // .ff-paragraph_text label {
        //     color: #74778c !important;
        // }

        small {
            color: #74778c !important;
            font-size: 12px; 
        }

        .ff-title {
            padding-top: 1em !important;
        }

        td {
            font-size: 13px;
            font-weight: bold !important;
            margin-top: 2em !important; 
        }

        @media only screen and (max-width: 600px) {
            td {
              font-size: 11px; 
            }
          }
        `}
    </style>
        <script async defer src="https://formfacade.com/include/105416567367288830990/form/1FAIpQLSfZw-9eNpZYw4lf2n93w2-4EhQ34uUJeWSQU-oNkY4abJCo6A/classic.js?div=ff-compose">
        </script></Helmet>


</>
)
} 

export default FormPage
